import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { productTypes } from '../../utils/enum/search-branches-enum';
import { content } from '../../contentData/branches';

interface Props {
  onComplete: (value: any) => void;
}
export default function FilterProductType({ onComplete }: Props) {
  const productTypeListOption = productTypes;

  const [selectProductType, setSelectProductType] = useState<string>('0');

  const handleChangeItemProductType = async (event: SelectChangeEvent) => {
    setSelectProductType(event.target.value as string);
    return onComplete(event.target.value as string);
  };

  return (
    <>
      <FormControl fullWidth variant="standard">
        <Select
          labelId="selectProductType"
          id="selectProductType"
          value={selectProductType}
          inputProps={{ 'aria-label': 'Without label' }}
          onChange={handleChangeItemProductType}
          sx={{ borderBottom: '1px solid #6D6D6D', color: '#263238' }}
          placeholder={content.productType.all}>
          <MenuItem key="0" value="0">
            {content.productType.all}
          </MenuItem>
          {productTypeListOption.map((item: any) => (
            <MenuItem key={item.type} value={item.type}>
              {item.type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
}
